import { z } from "zod";

import { ProfessionSchema } from "api/schemas/shared";
import { BookingIntervalResponseSchema } from "api/services/appointment/schemas/booking_interval";
import { MediumSchema, PurposeSchema, StateSchema } from "api/services/appointment/schemas/shared";

const PaymentMethodSchema = z.enum(["none", "bank_card", "on_site", "exemption_card", "free"]).nullable();

const HealthCareProfessionalSchema = z.object({
  id: z.number(),
  full_name: z.string(),
  profession: ProfessionSchema,
});

export const AppointmentV2Schema = z.object({
  id: z.number(),
  medium: MediumSchema,
  purpose: PurposeSchema,
  start_time: z.string(),
  end_time: z.string(),
  state: StateSchema.nullable(),
  note: z.string().nullable().optional(),
  health_care_provider_service_id: z.number().nullable(),
  health_care_provider_service_name: z.string().nullable(),
  health_care_provider_service_mode: z.enum(["digital", "physical"]).nullable(),
  capacity: z.number().nullable(),
  cents: z.number().nullable(),
  currency: z.string().nullable(),
  payer: z
    .object({
      payer_name: z.string().nullable().optional(),
    })
    .nullable()
    .optional(),
  payment_method: PaymentMethodSchema,
  payment_state: z.enum(["exempted", "paid", "unpaid"]).nullable(),
  health_care_professional: HealthCareProfessionalSchema,
  health_care_professional_id: z.number(),
  health_care_professional_full_name: z.string(),
  participants: z
    .object({
      id: z.number(),
      full_name: z.string().nullable(),
      phone_number: z.string().nullable(),
    })
    .array(),
});

export const AppointmentsV2ResponseSchema = z.object({
  appointments: AppointmentV2Schema.array(),
  booking_intervals: BookingIntervalResponseSchema.array(),
});

export type PaymentMethod = z.infer<typeof PaymentMethodSchema>;
export type AppointmentV2 = z.infer<typeof AppointmentV2Schema>;
export type AppointmentsV2Response = z.infer<typeof AppointmentsV2ResponseSchema>;

export type ApppointmentV2Payload = {
  end_time: string;
  health_care_provider_service_id: number;
  medium: string;
  note?: string;
  patient_id: number;
  start_time: string;
};

export type PostAppointmentV2Args = {
  data: ApppointmentV2Payload;
  hcProfId: number;
};

export type PutAppointmentV2Args = PostAppointmentV2Args & { appointmentId: number };

export type ApppointmentV2PayloadManager = ApppointmentV2Payload & {
  health_care_professional_id: number;
};

export type PostAppointmentV2ManagerArgs = {
  data: ApppointmentV2PayloadManager;
  managerId: number;
};

export type PutAppointmentV2ManagerArgs = PostAppointmentV2ManagerArgs & { appointmentId: number };
